import React, { useState } from "react";
import { useSubject } from "../../context/SubjectContext";
import MarkSubmissionConfirmModal from "../MarkSubmission/MarkSubmissionConfirmModal";
import "./ACMarksCentrePanel.css";
import { useLocation,  } from "react-router-dom";
import AssessmentCriteriaTable from "../../components/AssessmentCriteria/AssessmentCriteriaTable";
import AssessmentCriteriaHeader from "../../components/AssessmentCriteria/AssessmentCriteriaHeader";
import { getCenterType, checkunitIsConsortiaUnit } from "../../utils/utils";
import { useUnits } from "../../context/UnitsContext";
import { useCenter } from "../../context/CenterContext";

import PropTypes from "prop-types";
import { useConsortiaCenter } from "../../context/ConsortiaCenterContext";
const ACMarksCentrePanel = ({
  assessmentCandidateData,
  selectedCandidate,
  achievedCount = 0,
  totalCriteria = 0,
  totalMarks = 0,
  candidateDataMap,
  allCandidatesCompleted,
  criteriaDetails,
  values,
  notes,
  onSave,
  onChangeValue,
  onChangeNote,
  submissionPayload,
  onSubmit,
  showModal,
  setShowModal,
  missingOrInvalidCandidates,
  mode = "edit",
}) => {
  const { subjectData } = useSubject();
  const [isChecked, setIsChecked] = useState(false);
  const { candidateMarks } = candidateDataMap[selectedCandidate] || {};

  const { selectedSubject, selectedSubjectCode, selectedSubjectId } = subjectData || {};

  const location = useLocation();
  const { unit, sessionId, sessionStartDate, sessionEndDate, visitDate } =
    location.state || {};

  const onClose = () => {
    setShowModal(false);
    setIsChecked(false);
  };
  const { consortiaUnits = [] } = useUnits();

  const { centerNumber } = useCenter();
  const { consortiaCentres = [] } = useConsortiaCenter();

  const currentCentreType =
    getCenterType(consortiaCentres, Number(centerNumber), selectedSubject, selectedSubjectId) || "";
  const unitcode = unit.split(" ")[0];
  const consortiaUnitcode =
    String(unit ?? "")
      .toUpperCase()
      .match(/^[A-Z0-9]+/)?.[0] || "";
  const isConsortiaUnit = checkunitIsConsortiaUnit(
    consortiaCentres,
    centerNumber,
    sessionId,
    consortiaUnitcode,
  );

  return (
    <div id="pageMainContent">
      <MarkSubmissionConfirmModal
        isOpen={showModal}
        onClose={onClose}
        rows={submissionPayload}
        isChecked={isChecked}
        setIsChecked={setIsChecked}
        type={"acmarks"}
        assessmentCandidateData={assessmentCandidateData}
      />
      <div id="pageMainContent" style={{ paddingLeft: "240px" }}>
        <AssessmentCriteriaHeader
          selectedSubject={selectedSubject}
          selectedSubjectCode={selectedSubjectCode}
          visitDate={visitDate}
          sessionId={sessionId}
          sessionStartDate={sessionStartDate}
          sessionEndDate={sessionEndDate}
          unit={unit}
          mode={mode}
          onSave={onSave}
          submissionPayload={submissionPayload}
          subjectData={subjectData}
          selectedCandidate={selectedCandidate}
          candidateDataMap={candidateDataMap}
          onSubmit={onSubmit}
          allCandidatesCompleted={allCandidatesCompleted}
          missingOrInvalidCandidates={missingOrInvalidCandidates}
          assessmentCandidateData={assessmentCandidateData}
          achievedCount={achievedCount}
          totalCriteria={totalCriteria}
          candidateMarks={candidateMarks}
          totalMarks={totalMarks}
        />
        <div className="xcontainer" style={{ backgroundColor: "#FFFFFF" }}>
          <section
            className="section mt-0 py-0 pr-4"
            style={{ padding: "3rem" }}
          >
            {missingOrInvalidCandidates?.length > 0 && (
              <div>
                <div
                  id="notificationPanel"
                  className="notification-panel mt-2 mb-2"
                  role="alert"
                  aria-live="polite"
                  style={{ display: "block" }}
                >
                  <div className="notification-title">
                    <span className="icon" aria-hidden="true">
                      <i className="fas fa-exclamation-triangle"></i>
                    </span>
                    <span>
                      The following candidates have missing or incorrect
                      assessment criteria.
                    </span>
                  </div>
                  <div className="missing-candidates-list">
                    <strong>{missingOrInvalidCandidates.join(", ")}</strong>
                  </div>
                  <div className="notification-content">
                    <div>
                      Please remember to submit this information 3 working days
                      ahead of your scheduled visit.
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="ac-centre-card mt-2">
              <div
                className="candidate-header is-fixed is-flex is-align-items-center"
                style={{
                  backgroundColor: "#F7F7F7",
                  justifyContent: "space-between",
                }}
              >
                <div
                  className="is-size-5"
                  style={{
                    lineHeight: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  {((currentCentreType === "Lead" && isConsortiaUnit) || (currentCentreType === 'Rest' && mode ==='view' && isConsortiaUnit) ) && (
                    <span style={{ fontSize: "13px", fontWeight: "500" }}>
                      CENTRE:{" "}
                      {assessmentCandidateData.find(
                        (val) =>
                          val.centreCandidateNumber === selectedCandidate,
                      )?.centreNumber || ""}
                    </span>
                  )}

                  {assessmentCandidateData.find(
                    (val) => val.centreCandidateNumber === selectedCandidate,
                  )?.candidateName || ""}

                  <span className="candidate-number has-text-weight-normal is-size-6">
                    {selectedCandidate}
                  </span>
                </div>

                <div
                  style={{ display: "flex", gap: "1rem", marginLeft: "auto" }}
                >
                  <div className="tag card xis-dark xis-medium p-5 has-background-white">
                    Criteria achieved:&nbsp;&nbsp;
                    <span className="is-size-6">
                      <span id="varCandidateScore">{achievedCount}</span>
                      {" / "}
                      <span>{totalCriteria}</span>
                    </span>
                  </div>

                  <div
                    className="tag card xis-dark xis-medium p-5"
                    style={{ backgroundColor: "#E0E0E0" }}
                  >
                    Total marks for this candidate:&nbsp;&nbsp;
                    <span className="is-size-6">
                      <span id="varCandidateScore">{candidateMarks}</span>
                      {" / "}
                      <span>{totalMarks}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="subject-page-content xmt-0"
              style={{ top: "216px", width: "100%" }}
            ></div>
          </section>
        </div>
        <AssessmentCriteriaTable
          criteriaDetails={criteriaDetails}
          values={values}
          notes={notes}
          onChangeValue={onChangeValue}
          onChangeNote={onChangeNote}
          mode={mode}
        />
      </div>
    </div>
  );
};

export default ACMarksCentrePanel;

ACMarksCentrePanel.propTypes = {
  assessmentCandidateData: PropTypes.object,
  selectedCandidate: PropTypes.object,
  achievedCount: PropTypes.number,
  totalCriteria: PropTypes.number,
  totalMarks: PropTypes.number,
  candidateDataMap: PropTypes.object,
  allCandidatesCompleted: PropTypes.bool,
  criteriaDetails: PropTypes.array,
  values: PropTypes.object,
  notes: PropTypes.object,
  onSave: PropTypes.func,
  onChangeValue: PropTypes.func,
  onChangeNote: PropTypes.func,
  submissionPayload: PropTypes.object,
  onSubmit: PropTypes.func,
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  missingOrInvalidCandidates: PropTypes.array,
  mode: PropTypes.oneOf(["edit", "view"]),
};
